import {
  Switch as MantineSwitch,
  type SwitchProps as MantineSwitchProps,
} from '@mantine/core';

import { GoogleFontIcon } from '../icons/GoogleFontIcon';

import styles from './switch.module.scss';

export type SwitchProps = {
  onChange?: (checked: boolean) => void;
} & Omit<MantineSwitchProps, 'onChange'>;

export function Switch({ onChange, ...props }: SwitchProps) {
  return (
    <MantineSwitch
      {...props}
      withThumbIndicator={false}
      onChange={(e) => onChange?.(e.target.checked)}
      classNames={{
        root: styles['root'],
        body: styles['body'],
        label: styles['label'],
        track: styles['track'],
        thumb: styles['thumb'],
      }}
      thumbIcon={
        <GoogleFontIcon
          name={props.checked ? 'check' : 'close'}
          className={styles['switch-thumb-icon']}
        />
      }
    />
  );
}
